module.exports = __webpack_public_path__ + "img/generic_icon.05edb871.png";